/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_N8n_Faq_3_QuestionInputs */

const en_svc_n8n_faq_3_question = /** @type {(inputs: Svc_N8n_Faq_3_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can you fix or extend workflows someone else built?`)
};

const lv_svc_n8n_faq_3_question = /** @type {(inputs: Svc_N8n_Faq_3_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai varat salabot vai paplašināt kāda cita veidotas darba plūsmas?`)
};

/**
* | output |
* | --- |
* | "Can you fix or extend workflows someone else built?" |
*
* @param {Svc_N8n_Faq_3_QuestionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_n8n_faq_3_question = /** @type {((inputs?: Svc_N8n_Faq_3_QuestionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_N8n_Faq_3_QuestionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_n8n_faq_3_question(inputs)
	return en_svc_n8n_faq_3_question(inputs)
});